import React, { PropsWithChildren } from "react";
import { useKeycloak } from "./keycloak-provider";
import { cleanLoginRedirectUri } from "../lib/loginRedirectUri";

export interface AuthenticationVerifierProps {
  propertyTicker?: string;
}

export function AuthenticationVerifier(props: PropsWithChildren<AuthenticationVerifierProps>) {
  const keycloak = useKeycloak();

  if (keycloak.authenticated) {
    return <>{props.children}</>;
  }

  // Never send the current URL as-is: after a session expiry it may still carry the OIDC
  // callback parameters, and Keycloak >= 26.7.3 rejects such a redirect_uri.
  keycloak.login({ redirectUri: cleanLoginRedirectUri() });
}
